import { useEffect } from 'react'
import PropTypes from 'prop-types'

const FormikAutoSubmit = ({ values, initialValues, submitForm = () => {} }) => {
  useEffect(() => {
    if (initialValues !== values) {
      submitForm()
    }
  }, [values, submitForm])

  return null
}

FormikAutoSubmit.propTypes = {
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  submitForm: PropTypes.func.isRequired,
}

export default FormikAutoSubmit
